<h2 class="text-navy text-base break-words" mat-dialog-title>
  {{ 'kimbo-layout.func-lock-label' | translate }}
</h2>
<mat-dialog-content>
  <div class="mt-5 flex flex-col gap-3">
    <div>
      {{ 'kimbo-layout.func-lock-desc' | translate }}
    </div>
    <div>
      {{ 'kimbo-layout.comeback-msg' | translate }}
    </div>
    <div>
      {{ 'kimbo-layout.thanks' | translate }}
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="w-full my-4 flex justify-center items-center">
    <button
      class="h-12 w-fit p-2"
      mat-raised-button
      color="primary"
      type="button"
      (click)="close()">
      <span>{{ 'kimbo-layout.understood' | translate }}</span>
    </button>
  </div>
</mat-dialog-actions>
